<template>
  <div class="view">
    <div class="left">
      <uiList
        class="list"
        :items="items"
        :search="'locale.ru'"
        :add="true"
        @click="select"
        @add="add"
      >
        <template v-slot:item="{ item }">
          <div class="list-item">
            {{ item.locale.ru }}
          </div>
        </template>
      </uiList>
    </div>

    <div class="w-70 item-details">
      <div class="global-id">{{ selected.id }}</div>
      <uiDevider />

      <div class="space-y-3">
        <uiInput v-model="selected.locale.en" label="EN Название" />

        <uiInput v-model="selected.locale.ru" label="RU Название" />

        <uiInput v-model="selected.locale.he" label="HE Название" />

        <uiInput v-model="selected.taksaId" label="Taksa ID" />

        <uiDropdown
          v-model="selected.kind"
          label="Тип"
          :options="['dog', 'cat']"
        />

        <uiDropdown
          v-model="selected.verysimilar"
          label="Очень похожие"
          :options="similarItems"
          :reduce="item => item.value"
          clearSearchOnSelect
          multiple
        />

        <uiDropdown
          v-model="selected.similar"
          label="Похожие"
          :options="similarItems"
          :reduce="item => item.value"
          clearSearchOnSelect
          multiple
        />

        <div class="flex space-x-3">
          <uiInput
            v-model="selected.weight.male.min"
            label="Вес мальчика"
            placeholder="Мин"
            mask="decimal"
          />
          <uiInput
            v-model="selected.weight.male.max"
            label=" "
            placeholder="Макс"
            mask="decimal"
          />
        </div>

        <div class="flex space-x-3">
          <uiInput
            v-model="selected.weight.female.min"
            label="Вес девочки"
            placeholder="Мин"
            mask="decimal"
          />
          <uiInput
            v-model="selected.weight.female.max"
            label=" "
            placeholder="Макс"
            mask="decimal"
          />
        </div>

        <div>
          <uiButton class="button" :loading="loading" @click="save">
            {{ button }}
          </uiButton>

          <uiButton
            class="button"
            color="light"
            v-if="this.selected.id !== 'new'"
            :loading="loading"
            @click="remove"
          >
            Удалить
          </uiButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API } from '@/config'

const getBaseSelected = () => ({
  id: 'new',
  locale: {
    en: '',
    ru: ''
  },
  kind: '',
  taksaId: '',
  weight: {
    male: {
      min: '',
      max: ''
    },
    female: {
      min: '',
      max: ''
    }
  },
  similar: [],
  verysimilar: []
})

export default {
  name: 'PetFood',
  data () {
    return {
      loading: false,
      items: [],
      selected: getBaseSelected()
    }
  },
  computed: {
    button () {
      if (this.selected.id === 'new') return 'Создать'
      return 'Сохранить'
    },
    similarItems () {
      return (this.items ?? [])
        .filter(breed => breed.id !== this.selected.id)
        .map(breed => {
          const label =
            (breed.name ?? '').toLowerCase() === 'метис'
              ? `${breed.name} (${breed.kind})`
              : breed.name

          return { label, value: breed.id }
        })
    }
  },
  created () {
    this.selectNew()
    this.preload()
  },
  methods: {
    async preload () {
      if (this.items.length) return

      let { data } = await this.$http.get(API.SERVICES.petBreeds)
      if (!data || data.err) return this.$notify(data.err)
      this.items = data
    },
    select (e) {
      this.selected = Object.assign(getBaseSelected(), structuredClone(e))
    },
    selectNew () {
      this.selected = getBaseSelected()
    },
    add () {
      if (this.selected.id === 'new') return
      this.selectNew()
    },
    async save () {
      if (this.loading) return
      this.loading = true

      const payload = {
        ...structuredClone(this.selected),
        weight: {
          male: {
            min: Number.parseFloat(this.selected.weight.male.min) || null,
            max: Number.parseFloat(this.selected.weight.male.max) || null
          },
          female: {
            min: Number.parseFloat(this.selected.weight.female.min) || null,
            max: Number.parseFloat(this.selected.weight.female.max) || null
          }
        }
      }

      let { data } = await this.$http.post(API.SERVICES.petBreeds, payload)
      if (!data || data.err) {
        this.$notify(data.err)
        return (this.loading = false)
      }

      let index = this.items.findIndex(p => p.id === data.id)
      this.items.splice(index, 1, data)
      this.selected = data

      this.loading = false
      // this.selectNew()
    },
    async remove () {
      let confirm = await this.$confirm(`Точно удаляем?`)
      if (!confirm) return

      if (this.loading) return
      this.loading = true

      let id = this.selected.id
      if (id === 'new') return

      let { data } = await this.$http.delete(API.SERVICES.petBreeds, {
        id
      })
      if (!data || data.err) {
        this.$notify(data.err)
        return (this.loading = false)
      }

      this.selectNew()

      let index = this.items.findIndex(p => p.id === id)
      this.items.splice(index, 1)
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.view {
  display: flex;
}

.list {
  .list-item {
    display: block;
    font-size: 16px;
    position: relative;
  }
}

.item-details {
  padding: 0 20px;

  .hint {
    font-size: 13px;
    opacity: 0.3;
  }

  .row {
    width: 280px;
    margin-bottom: 10px;
  }

  .button {
    margin: 20px 0;
  }
}
</style>
